// extracted by mini-css-extract-plugin
export default {"projectCard":"ProjectCard_projectCard__4aKuS","description":"ProjectCard_description__jgcEK","icon":"ProjectCard_icon__v0fi4"};